import { render, staticRenderFns } from "./EditClientComponent.vue?vue&type=template&id=45a0f9a1&"
import script from "./EditClientComponent.vue?vue&type=script&lang=ts&"
export * from "./EditClientComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports